import { registerVueComponentAndAngularBindings, declareComponents } from '/vodalys/vvuejs'
 
import VProjector from './VProjector.vue' 
registerVueComponentAndAngularBindings('vprojector:page', 'vprojector', VProjector)

import components from './component/**/*.vue'
declareComponents('components', components)